import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'Aurora' })({
    root: {
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        userSelect: 'none',
        boxSizing: 'border-box'
    }
});
